import { IFetchSODConflictsBody } from "../../../../common/SODUtils/SODconstants";
import {
  IBREntitlementsItem,
  IBRItem,
  IBRRequestAndItem,
  IBRRequestItem,
  IEntitlementItem,
  IEntitlementsAndBRItem,
  IEntitlementsBRItem,
} from "../../../../models/Entitlements";

export const actionTypes = {
  GET_ALL_RECOVERY_POINT_USERS: "GET_ALL_RECOVERY_POINT_USERS",
  GET_ALL_RECOVERY_POINT_USERS_SUCCESS: "GET_ALL_RECOVERY_POINT_USERS_SUCCESS",
  GET_ALL_RECOVERY_POINT_USERS_FAILURE: "GET_ALL_RECOVERY_POINT_USERS_FAILURE",

  SET_RECOVERY_POINT_SELECTED_USERS: "SET_RECOVERY_POINT_SELECTED_USERS",

  RECOVERY_POINT_MODIFY_ADDED_ABILITATIONS:
    "RECOVERY_POINT_MODIFY_ADDED_ABILITATIONS",
  MODIFY_ADDED_BR: "MODIFY_ADDED_BR",
  RECOVERY_POINT_MODIFY_DELETED_ABILITATIONS:
    "RECOVERY_POINT_MODIFY_DELETED_ABILITATIONS",
  MODIFY_REMOVED_BR: "MODIFY_REMOVED_BR",
  RECOVERY_POINT_MODIFY_MODIFIED_ABILITATIONS:
    "RECOVERY_POINT_MODIFY_MODIFIED_ABILITATIONS",

  RECOVERY_POINT_MODIFY_TOTAL_ABILITATIONS:
    "RECOVERY_POINT_MODIFY_TOTAL_ABILITATIONS",
  RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST:
    "RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST",
  RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST_SUCCESS:
    "RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST_SUCCESS",
  RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST_FAILURE:
    "RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST_FAILURE",

  MODIFY_TOTAL_ABILITATIONS_BR: "MODIFY_TOTAL_ABILITATIONS_BR",
  RECOVERY_POINT_OFFICE_ENTITLEMENT_REQUEST:
    "RECOVERY_POINT_OFFICE_ENTITLEMENT_REQUEST",
  RECOVERY_POINT_OFFICE_ENTITLEMENT_REQUEST_SUCCESS:
    "RECOVERY_POINT_OFFICE_ENTITLEMENT_REQUEST_SUCCESS",
  RECOVERY_POINT_OFFICE_ENTITLEMENT_REQUEST_FAILURE:
    "RECOVERY_POINT_OFFICE_ENTITLEMENT_REQUEST_FAILURE",
  ENTITLEMENT_REQUEST: "ENTITLEMENT_REQUEST",
  ENTITLEMENT_REQUEST_SUCCESS: "ENTITLEMENT_REQUEST_SUCCESS",
  ENTITLEMENT_REQUEST_FAILURE: "ENTITLEMENT_REQUEST_FAILURE",
  RECOVERY_POINT_CREATE_REQUEST: "RECOVERY_POINTCREATE_REQUEST",
  RECOVERY_POINT_CREATE_REQUEST_SUCCESS: "RECOVERY_POINTCREATE_REQUEST_SUCCESS",
  RECOVERY_POINT_CREATE_REQUEST_FAILURE: "RECOVERY_POINTCREATE_REQUEST_FAILURE",
  RESET_ABILITATIONS: "RESET_ABILITATIONS",
  RECOVERY_POINT_RESET_STATE: "RECOVERY_POINT_RESET_STATE",
  BAO_ENTITLEMENT_REQUEST: "BAO_ENTITLEMENT_REQUEST",
  BAO_ENTITLEMENT_REQUEST_SUCCESS: "BAO_ENTITLEMENT_REQUEST_SUCCESS",
  BAO_ENTITLEMENT_REQUEST_FAILURE: "BAO_ENTITLEMENT_REQUEST_FAILURE",
  ENTITLEMENTS_BUSINESS_ROLES_SELECTED: "ENTITLEMENTS_BUSINESS_ROLES_SELECTED",
  ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET:
    "ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET",
  RECOVERY_POINT_SET_EXISTING_SAME_DB: "RECOVERY_POINT_SET_EXISTING_SAME_DB",
  RECOVERY_POINT_GET_DATE_ABILITATIONS: "RECOVERY_POINT_GET_DATE_ABILITATIONS",
  RECOVERY_POINT_GET_DATE_ABILITATIONS_SUCCESS:
    "RECOVERY_POINT_GET_DATE_ABILITATIONS_SUCCESS",
  RECOVERY_POINT_GET_DATE_ABILITATIONS_FAILURE:
    "RECOVERY_POINT_GET_DATE_ABILITATIONS_FAILURE",
  REC_P_SET_START_END_DATE: "REC_P_SET_START_END_DATE",
  RECOVERY_SOD_CONFLICTS: "RECOVERY_SOD_CONFLICTS",
  RECOVERY_SOD_CONFLICTS_SUCCESS: "RECOVERY_SOD_CONFLICTS_SUCCESS",
  RECOVERY_SOD_CONFLICTS_FAILURE: "RECOVERY_SOD_CONFLICTS_FAILURE",
  RECOVERY_RESET_SOD_CONFLICTS: "RECOVERY_RESET_SOD_CONFLICTS",
};

export const resetState = () => ({
  type: actionTypes.RECOVERY_POINT_RESET_STATE,
});

export const entitlementRequest = (id: any[]) => ({
  type: actionTypes.RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST,
  id,
});

export const entitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const entitlementRequestFailure = (err: any) => ({
  type: actionTypes.RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const getPerDateAbilitations = (
  userCode: string | number,
  timeStamp: number
) => ({
  type: actionTypes.RECOVERY_POINT_GET_DATE_ABILITATIONS,
  payload: {
    userCode,
    timeStamp,
  },
});

export const getPerDateAbilitationsSuccess = (payload: any) => ({
  type: actionTypes.RECOVERY_POINT_GET_DATE_ABILITATIONS_SUCCESS,
  payload,
});

export const getPerDateAbilitationsFailure = (err: Error) => ({
  type: actionTypes.RECOVERY_POINT_GET_DATE_ABILITATIONS_FAILURE,
  err,
});

export const createRequest = (abilitationObj: FormData) => ({
  type: actionTypes.RECOVERY_POINT_CREATE_REQUEST,
  abilitationObj,
});

export const createRequestSuccess = () => ({
  type: actionTypes.RECOVERY_POINT_CREATE_REQUEST_SUCCESS,
});

export const createRequestFailure = (err: Error) => ({
  type: actionTypes.RECOVERY_POINT_CREATE_REQUEST_FAILURE,
  err,
});

export const getAllRecoveryPointUsersAction = (payload: any) => ({
  type: actionTypes.GET_ALL_RECOVERY_POINT_USERS,
  payload,
});

export const getAllRecoveryPointUsersSuccessAction = (payload: any) => ({
  type: actionTypes.GET_ALL_RECOVERY_POINT_USERS_SUCCESS,
  payload,
});

export const getAllRecoveryPointUsersFailureAction = (error: any) => ({
  type: actionTypes.GET_ALL_RECOVERY_POINT_USERS_FAILURE,
  error,
});

export const setRecoveryPointSelectedUsersAction = (payload: any) => ({
  type: actionTypes.SET_RECOVERY_POINT_SELECTED_USERS,
  payload,
});

export const modifyAddedAbilitations = (
  addedAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.RECOVERY_POINT_MODIFY_ADDED_ABILITATIONS,
  addedAbilitations,
});

export const modifyAddedBR = (addedBR: IBRItem[]) => ({
  type: actionTypes.MODIFY_ADDED_BR,
  addedBR,
});

export const modifyDeletedAbilitations = (
  deletedAbilitations: IEntitlementsAndBRItem[]
) => ({
  type: actionTypes.RECOVERY_POINT_MODIFY_DELETED_ABILITATIONS,
  deletedAbilitations,
});

export const modifyRemovedBR = (removedBR: IBRRequestAndItem[]) => ({
  type: actionTypes.MODIFY_REMOVED_BR,
  removedBR,
});

export const modifyModifiedAbilitations = (
  modifiedAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.RECOVERY_POINT_MODIFY_MODIFIED_ABILITATIONS,
  modifiedAbilitations,
});

export const modifyTotalAbilitations = (
  totalAbilitations: IEntitlementItem[]
) => ({
  type: actionTypes.RECOVERY_POINT_MODIFY_TOTAL_ABILITATIONS,
  totalAbilitations,
});

export const modifyTotalAbilitationsBR = (
  totalAbilitations: IBRRequestItem[]
) => ({
  type: actionTypes.MODIFY_TOTAL_ABILITATIONS_BR,
  totalAbilitations,
});

export const setStartEndDate = (
  startDate: number,
  endDate: number,
  id: string | number
) => ({
  type: actionTypes.REC_P_SET_START_END_DATE,
  payload: {
    startDate,
    endDate,
    id,
  },
});

export const baoEntitlementRequest = (id: string | number) => ({
  type: actionTypes.BAO_ENTITLEMENT_REQUEST,
  id,
});

export const businessRolesSelected = (
  payload: IEntitlementsBRItem[] | IBREntitlementsItem[]
) => ({
  type: actionTypes.ENTITLEMENTS_BUSINESS_ROLES_SELECTED,
  payload,
});

export const entitlementsListBusinessRolesSelectedReset = () => ({
  type: actionTypes.ENTITLEMENTS_BUSINESS_ROLES_SELECTED_RESET,
});

export const setExistingSameDb = (payload: any[]) => ({
  type: actionTypes.RECOVERY_POINT_SET_EXISTING_SAME_DB,
  payload,
});

export const sodConflictsAction = (payload: IFetchSODConflictsBody) => ({
  type: actionTypes.RECOVERY_SOD_CONFLICTS,
  payload,
});

export const sodConflictsActionSuccess = (payload: any[]) => ({
  type: actionTypes.RECOVERY_SOD_CONFLICTS_SUCCESS,
  payload,
});

export const sodConflictsActionFailure = (err: Error) => ({
  type: actionTypes.RECOVERY_SOD_CONFLICTS_FAILURE,
  err,
});

export const resetSodConflictsAction = () => ({
  type: actionTypes.RECOVERY_RESET_SOD_CONFLICTS,
});
